/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Button,
  Input,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { listVistFormBooking } from "./_requests";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDate } from "../../helpers/FunctionHelpers";
import { useDownloadExcel } from "react-export-table-to-excel";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";

const VistFormBooking = () => {
  const [bookings, setBookings] = useState<any>([]);
  const [dateRange, setDateRange] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredData, setFilteredData] = useState<any>([]);

  const tableRef = useRef<HTMLTableElement>(null);

  const fetchBookings = useCallback((customParams?: any) => {
    const params: any = customParams || {};

    if (!customParams && dateRange && dateRange.length > 0) {
      const start = new Date(dateRange[0]);
      start.setHours(0, 0, 0, 0);
      const end = new Date(dateRange[1] || dateRange[0]);
      end.setHours(23, 59, 59, 999);
      
      params["dateRange[]"] = [start.toISOString(), end.toISOString()];
      params.startDate = start.toISOString();
      params.endDate = end.toISOString();
      params.from_date = start.toISOString();
      params.to_date = end.toISOString();
    }

    console.log("VisitFormBooking API Fetch Params:", params);

    listVistFormBooking(params).then((res: any) => {
      console.log("listVistFormBooking ---res", res);
      let data = [];
      if (Array.isArray(res)) {
        data = res;
      } else if (res && res.status && Array.isArray(res.data)) {
        data = res.data;
      }
      setBookings(data);
    });
  }, [dateRange]);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  // Client-side search filtering
  useEffect(() => {
    console.log("Filtering data with term:", searchTerm);
    if (!searchTerm) {
      setFilteredData(bookings);
      return;
    }
    const search = searchTerm.toLowerCase();
    const filtered = bookings.filter((item: any) => {
      const name = (item.user?.name || "").toLowerCase();
      const email = (item.user?.email || "").toLowerCase();
      const mobile = (item.user?.mobile_number || "").toLowerCase();
      const bannerTitle = (item.banner?.title || "").toLowerCase();
      return (
        name.includes(search) ||
        email.includes(search) ||
        mobile.includes(search) ||
        bannerTitle.includes(search)
      );
    });
    setFilteredData(filtered);
  }, [searchTerm, bookings]);

  const onClear = () => {
    console.log("Clearing filters...");
    setDateRange("");
    setSearchTerm("");
    fetchBookings({}); // Force fetch all
  };

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return (
            cellProps.table.getSortedRowModel().flatRows.indexOf(cellProps.row) + 1
          );
        },
      },
      {
        header: "User Details",
        accessorKey: "user.name",
        cell: (cell: any) => {
          const user = cell.row.original.user;
          const initials = user?.name?.charAt(0).toUpperCase() || "U";
          const profileImage = user?.profile || user?.profile_photo || user?.profile_image || user?.image;
          
          return (
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-2">
                <div className="avatar-xs">
                  {profileImage && profileImage.length > 0 ? (
                    <img src={profileImage} alt="" className="avatar-title rounded-circle img-fluid" style={{ objectFit: "cover" }} />
                  ) : (
                    <span className="avatar-title rounded-circle bg-primary-subtle text-primary">
                      {initials}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex-grow-1">
                <h6 className="fs-14 mb-1">
                  <Link to={`/user/view/${user?.id}`} className="text-body fw-bold">
                    {user?.name || "-"}
                  </Link>
                </h6>
                <p className="text-muted mb-0">{user?.email || "-"}</p>
                <p className="text-muted mb-0">{user?.mobile_number || "-"}</p>
              </div>
            </div>
          );
        },
      },
      {
        header: "Banner Details",
        accessorKey: "banner.title",
        cell: (cell: any) => {
          const banner = cell.row.original.banner;
          if (!banner) return "-";

          return (
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-2">
                <div className="avatar-xs">
                  {banner.image && banner.image.length > 0 ? (
                    <img
                      src={banner.image}
                      alt=""
                      className="avatar-title rounded img-fluid"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <span className="avatar-title rounded bg-light text-muted">
                      <i className="ri-image-2-line fs-14"></i>
                    </span>
                  )}
                </div>
              </div>
              <div className="flex-grow-1" style={{ minWidth: "250px", maxWidth: "400px" }}>
                <div
                  className="fs-14 mb-0"
                  style={{ whiteSpace: "normal" }}
                  dangerouslySetInnerHTML={{ __html: banner.title || "-" }}
                />
              </div>
            </div>
          );
        },
      },
      {
        header: "Booking Date",
        accessorKey: "createdat",
        cell: (cell: any) => {
          const dateStr = formatDate(cell.getValue());
          return (
            <span className="badge bg-info-subtle text-info fs-12">
              <i className="ri-calendar-event-line align-bottom me-1"></i>
              {dateStr || "-"}
            </span>
          );
        },
      },
    ],
    [],
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Visit_Form_Bookings",
    sheet: "Bookings",
  });


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Visit Form Booking" pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center mb-3">
                    <Col sm={6}>
                      <h5 className="card-title mb-0">
                        Visit Form Booking List
                      </h5>
                    </Col>
                    <Col sm={6} className="text-end">
                      <div className="d-flex gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => onDownload()}
                        >
                          <i className="ri-file-excel-2-line align-bottom me-1"></i>{" "}
                          Export Excel
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="g-3">
                    <Col sm={5}>
                      <div className="search-box">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search name, email or mobile..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>
                    <Col sm={5}>
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                        }}
                        placeholder="Select Date Range"
                        value={dateRange}
                        onChange={(date: any) => setDateRange(date)}
                      />
                    </Col>
                    <Col sm={1}>
                      <Button
                        color="primary"
                        className="w-100"
                        onClick={() => fetchBookings()}
                      >
                        Apply
                      </Button>
                    </Col>
                    <Col sm={1}>
                      <Button
                        color="soft-secondary"
                        className="w-100"
                        onClick={() => onClear()}
                      >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <div style={{ display: "none" }}>
                  <table ref={tableRef}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Banner Title</th>
                        <th>Booking Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((elt: any, index: number) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{elt.user?.name || "-"}</td>
                          <td>{elt.user?.email || "-"}</td>
                          <td>{elt.user?.mobile_number || "-"}</td>
                          <td>{elt.banner?.title || "-"}</td>
                          <td>{formatDate(elt.createdat) || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="card-body pt-0 mt-4">
                  {filteredData.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={filteredData || []}
                      isGlobalFilter={false}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      theadClass="table-light fw-bold"
                    />
                  ) : (
                    <div className="py-4 text-center">No search data found</div>
                  )}
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VistFormBooking;
